import { NavLink } from "react-router-dom";
import { getSeoContentPageBySlug } from "../content/seoContentPages";
import "../style/seoContentPage.css";

export default function SeoContentPage({ slug }) {
  const page = getSeoContentPageBySlug(slug);

  if (!page) {
    return null;
  }

  return (
    <article className="seo-content-page">
      <header className="seo-content-hero">
        <span>QA Coder SEO Guide</span>
        <h1>{page.title}</h1>
        <p>{page.description}</p>
        <div className="seo-content-actions">
          {page.internalLinks.slice(0, 3).map((link) => (
            <NavLink to={link.to} key={link.to}>
              {link.label}
            </NavLink>
          ))}
        </div>
      </header>

      <div className="seo-content-layout">
        <main className="seo-content-card">
          {page.sections.map((section) => (
            <section key={section.heading} id={section.heading.toLowerCase().replaceAll(" ", "-")}>
              <h2>{section.heading}</h2>

              {section.paragraphs?.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}

              {section.list && (
                <ul>
                  {section.list.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              )}

              {section.faqs && (
                <div className="seo-faq-list">
                  {section.faqs.map((faq) => (
                    <details key={faq.question}>
                      <summary>{faq.question}</summary>
                      <p>{faq.answer}</p>
                    </details>
                  ))}
                </div>
              )}
            </section>
          ))}

          <section className="seo-internal-links">
            <h2>Continue learning with QA Coder</h2>
            <p>
              Use these related QA Coder resources to build topical authority and connect this guide
              with practical learning paths.
            </p>
            <div>
              {page.internalLinks.map((link) => (
                <NavLink to={link.to} key={link.to}>
                  {link.label}
                </NavLink>
              ))}
            </div>
          </section>
        </main>

        <aside className="seo-content-sidebar">
          <div className="seo-sidebar-card">
            <strong>On this page</strong>
            {page.sections.map((section) => (
              <a href={`#${section.heading.toLowerCase().replaceAll(" ", "-")}`} key={section.heading}>
                {section.heading}
              </a>
            ))}
          </div>
          <div className="seo-sidebar-card accent">
            <strong>Want guided training?</strong>
            <p>Join QA Coder for manual testing, automation, API testing, projects, and interview prep.</p>
            <NavLink to="/enroll">Join Live Course</NavLink>
          </div>
        </aside>
      </div>
    </article>
  );
}
